import { Box, Center } from "@chakra-ui/react"
import { ReactComponent as DashboardQapp } from "assets/icons/dashboard-qapp.svg"

const QappLogo = () => {
  return (
    <Box
      width="qapp_logo_width"
      height="qapp_logo_height"
      backgroundColor="#fff"
      boxShadow="0px 25px 50px #046CEC0D"
      borderRadius="30px"
      transform="rotate(15deg) translateX(-50%)"
      position="absolute"
      top="50px"
      left="50%"
    >
      <Center h="100%" transform="rotate(-15deg)">
        <DashboardQapp />
      </Center>
    </Box>
  )
}

export default QappLogo
